import Vue from 'vue';
import App from './App';
import {router} from './router';
import * as filter from './utils/filters'
import 'amfe-flexible';
// import './utils/rem'
import {VueAxios} from "@/utils/request"
import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.use(VueAxios, router);
Vue.use(SlideVerify);
//注册全局过滤器
for (let key in filter) {
    Vue.filter(key, filter[key])
}

new Vue({
    router,
    el: '#app',
    render: h => h(App)
});
